export default __webpack_public_path__ + "static/media/T_sound.33ea1976.mp3";